import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isVehicle: '', 
  routeReplayVehicleId: '', // Vehicle selected specifically for Route Replay, isolated from isVehicle
  autoLoadRoute: false,
  selectedStartTime: "", // Add this
  selectedEndTime: "",
  fleetStats: {
    total: 0,
    running: 0,
    idle: 0,
    parked: 0,
    offline: 0,
    onRoute: 0
  }
};

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    setIsVehicle(state, action) {
      state.isVehicle = action.payload; 
    },
    setRouteReplayVehicle(state, action) {
      state.routeReplayVehicleId = action.payload;
    },
    setAutoLoadRoute(state, action) {
      state.autoLoadRoute = action.payload;
    },
    setStoredTimes: (state, action) => {
    state.selectedStartTime = action.payload.start;
    state.selectedEndTime = action.payload.end;
  },
  setFleetStats(state, action) {
      state.fleetStats = action.payload;
    },
    resetIsVehicle(state) {
      state.isVehicle = '';
      state.autoLoadRoute = false;
    },
    resetRouteReplayVehicle(state) {
      state.routeReplayVehicleId = '';
      state.autoLoadRoute = false;
    },
  },
});


export const { setIsVehicle, setRouteReplayVehicle, setAutoLoadRoute, resetIsVehicle, resetRouteReplayVehicle, setStoredTimes, setFleetStats } = vehicleSlice.actions;

export default vehicleSlice.reducer;